// extracted by mini-css-extract-plugin
export default {"body":"Join_body__DtVlM"};